import tenantRoutes from '@routes';
import TenantComponents from '@tenantComponents';
import React, { Suspense, useCallback } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Spinner, NationalDayModal } from './components/common';
import Page from './container';
import { useScrollToTop } from './hooks';
import withAdminLayout from './layout/withAdminLayout';
import { stSlash } from './utility/utility';
import { useSelector } from 'react-redux';

const Home = () => {
  const { user } = useSelector((state) => state.app.loginUser);
  useScrollToTop();

  const getAppRoutes = useCallback(() => {
    return tenantRoutes.app(stSlash(''), true, user);
  // `eligible_for_bundles` can arrive after the user (zameen reads it from /bundles), and it gates a route.
  }, [user?.id, user?.eligible_for_bundles]);

  return (
    <>
      <Suspense fallback={<Spinner type="full" />}>
        <Routes>
          {getAppRoutes().map((e) => {
            const Component = Page[e.Component];
            return <Route key={e.path} path={e.path} element={<Component />} />;
          })}
        </Routes>
      </Suspense>

      {user && (
        <>
          <NationalDayModal />
          <TenantComponents.BundleDiscountModal />
        </>
      )}
    </>
  );
};

export default withAdminLayout(Home);
